import { render, staticRenderFns } from "./DeputySelect.vue?vue&type=template&id=7467f1ed"
import script from "./DeputySelect.vue?vue&type=script&lang=js"
export * from "./DeputySelect.vue?vue&type=script&lang=js"
import style0 from "./DeputySelect.vue?vue&type=style&index=0&id=7467f1ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports